/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ChangeEvent, useEffect, useRef, useState } from 'react'

import 'react-circular-progressbar/dist/styles.css'
import { CircularProgressbar } from 'react-circular-progressbar'

import { Accordion, AccordionItem } from '../components/Accordion'
import UiSelect from '../../../components/UI/UISelect'
import UIButton from '../../../components/UI/UIButton'
import UITextInput from '../../../components/UI/UITextInput'
import UISubHeaderComponent from '../../../components/UI/UISubHeaderComponent'
import UIStaightlineProressBar from '../../../components/UI/UIStaightlineProressBar'
import {
  UploadResponse,
  safeguardingCategoriesResponse,
  safeguardingCategoriesResponseObj,
  safeguardingRecords,
  safeguardingResponse,
} from '../../../utils/types'
import {
  getProfileSafeguardingRecord,
  getSafeguardingRecordCategories,
  updateProfileSafeguardingRecord,
} from '../../../api/candidate/myscrApis'
import { toast } from 'react-toastify'
import { useQuery } from 'react-query'
import UIDatePickerv from '../../../components/UI/UIDatePickerv'
import UIDocumentPicker from '../../../components/UI/UIDocumentPicker'
import { fileUpload } from '../../../api/apiService'
import {
  calculateNonNullPercentage,
  getSafeguardingScoreFields,
  aggregateSafeguardingScore,
} from '../../../utils/utils'
import Modal from '../../../components/UI/UIModal'
import { Icon } from '../../../components/Icon'
// import UIDatePickerv from '../../../components/UI/UIDatePickerv'

export interface safeguardingRecordsData {
  id?: string
  userId?: string
  safeguardingRecordCategoryId?: string
  verifiedBy?: string
  verifiedByName?: string
  isRejected?: boolean
  verificationDate?: string
  documentType?: string
  documentNo?: string
  document?: string
  riskAssessmentStatus?: string
  issueDate?: string
  expiryDate?: string
  riskDocument?: string
  duration?: string
  title?: string
  referenceUrl?: string
  isExpiryDate?: string
  isIssueDate?: string
  isRiskAssessment?: string
}

export interface createSafeguardingRecordFormDataInterface {
  safeguardingRecordCategoryId?: string
  verifiedBy?: string
  verificationDate?: string
  documentType?: string
  documentNo?: string
  document?: string
  riskAssessmentStatus?: string
  issueDate?: string
  expiryDate?: string
  riskDocument?: string
  duration?: string
  title?: string
}

export interface updateSafeguardingRecordFormDataInterface {
  id?: string
  safeguardingRecordCategoryId?: string
  verifiedBy?: string
  verificationDate?: string
  documentType?: string
  documentNo?: string
  document?: string
  riskAssessmentStatus?: string
  issueDate?: string
  expiryDate?: string
  riskDocument?: string
  duration?: string
  title?: string
}
type TrainingRecord = {
  id?: string
  userId: string
  trainingRecordCategoryId: string
  schoolId?: string
  certificateNumber: string | null
  date: string | null
  reviewDate: string | null
  verifiedBy: string | null
  verificationDate: string | null
  riskAssessmentStatus: string | null
  duration: string | null
  certificate: string | null
}

const SafeguardingRecords = () => {
  const divRef = useRef<HTMLDivElement>(null)
  const [alertActive, setAlertActive] = useState(false)
  const [isOpenAlert, setIsOpenAlert] = useState(false)
  const [isUpdateLoading, setIsUpdateLoading] = useState<boolean>(false)

  const [safeguardingRecordsData, setSafeguardingRecordsData] =
    useState<safeguardingRecordsData[]>()
  const [createRecordFormData, setCreateRecordFormData] = useState<
    createSafeguardingRecordFormDataInterface[]
  >([])
  const [updateRecordFormData, setUpdateRecordFormData] = useState<
    updateSafeguardingRecordFormDataInterface[]
  >([])

  const fetchSafeguardingRecordCategories =
    async (): Promise<safeguardingCategoriesResponseObj> => {
      const response =
        (await getSafeguardingRecordCategories()) as safeguardingCategoriesResponse
      if (response?.status != 'successful') {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
      return response?.data
    }

  const fetchSafeguardingRecord = async (): Promise<safeguardingRecords[]> => {
    const response =
      (await getProfileSafeguardingRecord()) as safeguardingResponse
    if (response?.status != 'successful') {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
    return response?.data
  }

  const {
    data: safeguardingRecords,
    isLoading: isLoadingRecords,
    isError: isErrorRecords,
    refetch: refetchRecords,
  } = useQuery('userTraining', fetchSafeguardingRecord)
  const {
    data: safeguardingCategories,
    isLoading: isLoadingCategories,
    isError: isErrorCategories,
    refetch: refetchCategories,
  } = useQuery('trainingRecordCategories', fetchSafeguardingRecordCategories)

  const convertToUndefined = (value: any) => (value ? value : undefined)

  useEffect(() => {
    if (safeguardingRecords !== undefined) {
      const mergedArray = safeguardingCategories?.data?.map((category) => {
        const matchingRecords =
          safeguardingRecords?.filter(
            (record) => record.safeguardingRecordCategoryId === category.id
          ) || []
        // If no matching records are found, include only the category title
        if (matchingRecords.length === 0) {
          return {
            title: category.title,
            safeguardingRecordCategoryId: category.id,
            isExpiryDate: category.expiryDate,
            isIssueDate: category.issueDate,
            isRiskAssessment: category.riskAssessment,
          }
        } else {
          let obj = {}
          matchingRecords.map((record: any) => {
            const updatedRecord: any = {}
            for (const key in record) {
              // eslint-disable-next-line no-prototype-builtins
              if (record.hasOwnProperty(key)) {
                updatedRecord[key] = convertToUndefined(record[key])
              }
            }
            obj = {
              ...updatedRecord,
              title: category.title,
              isExpiryDate: category.expiryDate,
              isIssueDate: category.issueDate,
              isRiskAssessment: category.riskAssessment,
            }
          })
          return obj
        }
      })
      if (mergedArray) setSafeguardingRecordsData(mergedArray)
    }
  }, [safeguardingRecords, safeguardingCategories])

  const handleChange = (
    fieldName: string,
    value: string | boolean,
    item: safeguardingRecordsData
  ) => {
    if (Object.keys(item)?.length > 3) {
      setSafeguardingRecordsData((prev) => {
        if (!prev) {
          // If previous state is undefined, return a new array with the updated item
          return [
            {
              ...item,
              [fieldName]: value,
            },
          ]
        }
        // Check if the item exists in the previous state
        const existingItemIndex = prev.findIndex(
          (record) =>
            record.safeguardingRecordCategoryId ===
            item.safeguardingRecordCategoryId
        )
        if (existingItemIndex !== -1) {
          // If the item exists, update the specified field name with the provided value
          return prev.map((record, index) => {
            if (index === existingItemIndex) {
              return {
                ...record,
                [fieldName]: value,
              }
            }
            return record
          })
        } else {
          // If the item doesn't exist, add it and update the specified field name with the provided value
          return [
            ...prev,
            {
              ...item,
              [fieldName]: value,
            },
          ]
        }
      })
      setUpdateRecordFormData((prev) => {
        if (!prev) {
          // If previous state is undefined, return a new array with the updated item
          return [
            {
              ...item,
              [fieldName]: value,
            },
          ]
        }
        // Check if the item exists in the previous state
        const existingItemIndex = prev.findIndex(
          (record) =>
            record.safeguardingRecordCategoryId ===
            item.safeguardingRecordCategoryId
        )
        if (existingItemIndex !== -1) {
          // If the item exists, update the specified field name with the provided value
          return prev.map((record, index) => {
            const { title, ...rest } = record
            if (index === existingItemIndex) {
              return {
                ...rest,
                [fieldName]: value,
              }
            }
            return record
          })
        } else {
          // If the item doesn't exist, add it and update the specified field name with the provided value
          return [
            ...prev,
            {
              ...item,
              [fieldName]: value,
            },
          ]
        }
      })
    } else {
      if (fieldName == 'certificate' || undefined) {
        setSafeguardingRecordsData((prev) => {
          if (!prev) {
            // If previous state is undefined, return a new array with the updated item
            return [
              {
                ...item,
                [fieldName]: value,
              },
            ]
          }
          // Check if the item exists in the previous state
          const existingItemIndex = prev.findIndex(
            (record) =>
              record.safeguardingRecordCategoryId ===
              item.safeguardingRecordCategoryId
          )
          if (existingItemIndex !== -1) {
            // If the item exists, update the specified field name with the provided value
            return prev.map((record, index) => {
              if (index === existingItemIndex) {
                return {
                  ...record,
                  [fieldName]: value,
                }
              }
              return record
            })
          } else {
            // If the item doesn't exist, add it and update the specified field name with the provided value
            return [
              ...prev,
              {
                ...item,
                [fieldName]: value,
              },
            ]
          }
        })
      }
      setCreateRecordFormData((prev) => {
        const matchingRecords =
          prev?.filter(
            (record) =>
              record.safeguardingRecordCategoryId ===
              item.safeguardingRecordCategoryId
          ) || []
        if (matchingRecords.length === 0) {
          const newItem = {
            ...item,
            [fieldName]: value,
          }
          return [...prev, newItem]
        } else {
          const updatedRecords =
            prev?.map((record) => {
              if (
                record.safeguardingRecordCategoryId ===
                item.safeguardingRecordCategoryId
              ) {
                const { title, ...rest } = record
                return {
                  ...rest,
                  [fieldName]: value,
                }
              }
              return record
            }) || []

          return updatedRecords
        }
      })
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleFileChange = async (
    category: string,
    event: ChangeEvent<HTMLInputElement>,
    item: safeguardingRecordsData
  ) => {
    const file = event.target.files?.[0]
    if (file) {
      try {
        const response = (await fileUpload({
          file: file,
          category: 'user_document',
        })) as UploadResponse
        toast.success(response?.message, {
          position: 'top-right',
        })
        handleChange('document', response?.url, item)
      } catch (error) {
        handleChange('document', item?.document ? item?.document : '', item)
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    }
    event.target.value = ''
  }

  type AnyObject = { [key: string]: any }
  type AnyArray = any[]
  function convertNullsToUndefined(
    obj: AnyObject | AnyArray,
    columnsToRemove?: string[]
  ): AnyObject | AnyArray | undefined {
    if (Array.isArray(obj)) {
      return obj.map((item) => convertNullsToUndefined(item, columnsToRemove))
    } else if (obj !== null && typeof obj === 'object') {
      return Object.keys(obj).reduce((acc: AnyObject, key: string) => {
        if (!columnsToRemove?.includes(key)) {
          // Check if the key is not in the columns to remove
          acc[key] = convertNullsToUndefined(obj[key], columnsToRemove)
        }
        return acc
      }, {})
    } else {
      return obj === null ? undefined : obj
    }
  }

  const handleUpdateRecords = async (): Promise<void> => {
    setIsUpdateLoading(true)
    try {
      setIsUpdateLoading(true)
      const convertedValues = convertNullsToUndefined(updateRecordFormData, [
        'isExpiryDate',
        'verifiedByName',
        'documentUrl',
        'riskDocumentUrl',
        'isIssueDate',
        'isRiskAssessment',
        'id',
      ])
      const response = (await updateProfileSafeguardingRecord(
        convertedValues as any
      )) as {
        status?: string
        data: safeguardingRecords
      }
      if (response?.status == 'successful') {
        setUpdateRecordFormData([])
        refetchCategories()
        refetchRecords()
        toast.success('Records Updated.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('An error occurred while updating records.', {
        position: 'top-right',
      })
    } finally {
      setIsUpdateLoading(false)
    }
  }

  const handleClickOutside = (event: MouseEvent) => {
    if (
      divRef.current &&
      !divRef.current.contains(event.target as Node) &&
      alertActive
    ) {
      setIsOpenAlert(true)
    } else if (isOpenAlert == false) {
      setAlertActive(false)
    }
  }

  useEffect(() => {
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [alertActive])

  // Overall scorecard = every field of every category, scored as one set.
  // Field set + scoring are shared via utils so this view matches the admin /
  // lead views exactly (see getSafeguardingScoreFields).
  const scorecard = aggregateSafeguardingScore(
    safeguardingCategories?.data,
    safeguardingRecordsData
  )

  return (
    <div
      ref={divRef}
      className={
        'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-5 '
      }
    >
      <div
        style={{
          height: 'calc(100vh - 100px)',
          overflow: 'auto',
          // scrollbarWidth: 'none',
        }}
      >
        <UISubHeaderComponent
          mainPage="My SCR Overview"
          subPage="Safeguarding Records"
          //copy="This is where all of your training records are gathered. You can get a full overview of all the completed and outstanding details needed for your record."
          onDelete={() => {}}
          isViewMode={false}
          isCreatePolicy={false}
        />
        <div className="flex my-8 gap-2">
          {/* First column */}
          <div
            style={{
              // height: 'calc(100vh - 100px)',
              overflow: 'auto',
              scrollbarWidth: 'none',
            }}
            className="flex flex-col w-8/12 gap-4"
          >
            {safeguardingRecordsData?.map(
              (item: safeguardingRecordsData, index: number) => {
                return (
                  <Accordion key={index} defaultActiveIndex={null}>
                    <AccordionItem
                      onClick={() => console.log('')}
                      title={item?.title ? item?.title : ''}
                      isActive={false}
                    >
                      <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                        <div className="flex w-full gap-4">
                          <div className="w-6/12  ">
                            <UiSelect
                              onChange={(e: string) => {
                                handleChange('documentType', e, item)
                              }}
                              value={
                                item?.documentType ? item?.documentType : ''
                              }
                              options={[
                                { value: 'Passport', label: 'Passport' },
                                {
                                  value: 'Driving License',
                                  label: 'Driving License',
                                },
                                {
                                  value: 'Birth Certificate',
                                  label: 'Birth Certificate',
                                },
                                {
                                  value: 'Certificate',
                                  label: 'Certificate',
                                },
                                {
                                  value: 'Other',
                                  label: 'Other',
                                },
                              ]}
                              title={'Document Type'}
                            />
                          </div>
                          <div className="w-6/12  ">
                            <UITextInput
                              placeholder={'Document No'}
                              label={'Document No'}
                              iconName={''}
                              value={item?.documentNo ? item?.documentNo : ''}
                              onChange={(e) =>
                                handleChange('documentNo', e.target.value, item)
                              }
                            />
                          </div>
                        </div>

                        <UIDocumentPicker
                          isRejected={item.isRejected}
                          id={item?.title ? item?.title : 'pickerInput'}
                          handleRemoveFile={() => {
                            handleChange('document', '', item)
                          }}
                          label={'Document'}
                          initialValue={item?.document ? item?.document : ''}
                          onChange={(e) =>
                            handleFileChange('document', e, item)
                          }
                          accept=".pdf, .doc, .docx, .jpg, .jpeg, .png, .svg"
                          labelClassName="custom-label-class"
                        />

                        <div className="flex w-full gap-4">
                          {item.isIssueDate && (
                            <div className="w-6/12  ">
                              <UIDatePickerv
                                placeholderText={'Not Specified'}
                                title={'Issue Date'}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleChange(
                                    'issueDate',
                                    e.target.value,
                                    item
                                  )
                                }}
                                value={
                                  item?.issueDate
                                    ? item?.issueDate.split('T')[0]
                                    : ''
                                }
                              />
                            </div>
                          )}
                          {item.isExpiryDate && (
                            <div className="w-6/12">
                              <UIDatePickerv
                                placeholderText={'Not Specified'}
                                title={'Expiry Date'}
                                value={
                                  item?.expiryDate
                                    ? item?.expiryDate.split('T')[0]
                                    : ''
                                }
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleChange(
                                    'expiryDate',
                                    e.target.value,
                                    item
                                  )
                                }}
                              />
                            </div>
                          )}
                        </div>
                        <div className="flex w-full gap-4">
                          <div className="w-6/12  ">
                            <UITextInput
                              readOnly
                              placeholder={'Not specified'}
                              label={'Verified by'}
                              iconName={''}
                              value={item?.verifiedByName || ''}
                            />
                          </div>
                          <div className="w-6/12">
                            <UIDatePickerv
                              readOnly
                              placeholderText={'Not Specified'}
                              title={'Verification Date'}
                              value={
                                item?.verificationDate
                                  ? item?.verificationDate.split('T')[0]
                                  : ''
                              }
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                handleChange(
                                  'verificationDate',
                                  e.target.value,
                                  item
                                )
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </AccordionItem>
                  </Accordion>
                )
              }
            )}
          </div>

          {/* Second column */}
          <div className="w-4/12">
            <Accordion defaultActiveIndex={0}>
              <AccordionItem
                onClick={() => console.log('')}
                title={'Scorecard'}
                isActive={true}
                AccordionItemStyle={{
                  backgroundColor: 'rgba(230, 240, 243, 1)',
                }}
                AccordiontitleStyle={
                  'text-sm text-bluishGreen flex-1 font-semibold'
                }
                AccordionItemStyleContainer={{
                  backgroundColor: 'rgba(242, 247, 249, 1)',
                }}
                icon={'IconBarChartSquare'}
              >
                <div className="bg-gray1 flex items-center flex-col justify-center gap-4 my-8">
                  <div className="w-[160px] h-[160px]">
                    <CircularProgressbar
                      strokeWidth={5}
                      value={scorecard.percentage}
                      text={`${scorecard.percentage}%`}
                      styles={{
                        root: {},
                        path: {
                          stroke: scorecard.color,
                          transition: 'stroke-dashoffset 0.5s ease 0s',
                        },
                        text: {
                          fill: '#013546',
                          fontSize: '24px',
                          fontWeight: 700,
                          lineHeight: 40,
                        },
                      }}
                    />
                  </div>
                  <div className="items-center justify-center flex">
                    <p className="text-sm font-semibold  w-[80%]  text-text2 leading-6 text-center">
                      {scorecard.percentage == 100
                        ? 'Well done you reached 100%'
                        : scorecard.percentage == 0
                          ? 'Make a start to improve your score'
                          : 'Great start! But there is still room for improvement'}
                    </p>
                  </div>
                  <Accordion defaultActiveIndex={0}>
                    <AccordionItem
                      onClick={() => console.log('Accordion')}
                      title={'Your score is broken down as follows:'}
                      isActive={false}
                      AccordionItemStyle={{ backgroundColor: '#FFFFFF' }}
                      AccordiontitleStyle={
                        'text-xs font-semibold text-text4 leading-5 flex-1'
                      }
                      AccordionItemStyleContainer={{
                        backgroundColor: '#FFFFFF',
                      }}
                    >
                      <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                        {safeguardingCategories?.data?.map((item, index) => {
                          const fieldsToCheck = getSafeguardingScoreFields(
                            item,
                            safeguardingRecordsData?.[index]
                          )

                          return (
                            <div key={index} className="">
                              <div className="">
                                <UIStaightlineProressBar
                                  percentage={
                                    calculateNonNullPercentage(fieldsToCheck)
                                      .percentage
                                  }
                                  label={item?.title}
                                  stroke={
                                    calculateNonNullPercentage(fieldsToCheck)
                                      .color
                                  }
                                  strokeWidth={1.5}
                                />
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </AccordionItem>
                  </Accordion>
                </div>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
        <div className="bg-gray3 w-full h-[1px] my-3"></div>
        <div className="w-[33%] mt-6">
          <UIButton
            loading={isUpdateLoading}
            onClick={handleUpdateRecords}
            label="Update"
          />
        </div>
      </div>
      <Modal
        customStyle={{ width: '480px', borderRadius: 16 }}
        isOpen={isOpenAlert}
        onClose={() => {
          setIsOpenAlert(false)
        }}
      >
        <div
          className={
            'max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={() => {
              setIsOpenAlert(false)
            }}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#FF6666'}
              strokeWidth={1}
              height={52}
              width={52}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Save changes?
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Do you want to save changes before moving on?{' '}
            </p>
          </div>

          <button
            onClick={() => {
              setIsOpenAlert(false)
            }}
            className=" text-textError border-textError border-[1px] min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Yes, I am Sure
          </button>
          <button
            onClick={() => {
              setIsOpenAlert(false)
            }}
            className=" text-text3 border-textError bg-gray2 min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Cancel
          </button>
        </div>
      </Modal>
    </div>
  )
}

export default SafeguardingRecords
